import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const menuList = (query) => axiosInstance.get('/appearance/menu/list', { params: { ...pickDevParams, ...query } });
export const menuDelete = (id) => axiosInstance.post(`/appearance/menu/delete/${id}`, { ...pickDevParams });
export const menuCreate = (body) => axiosInstance.post('/appearance/menu/create', { ...body, ...pickDevParams });
export const menuEdit = (id, body) => axiosInstance.post(`/appearance/menu/edit/${id}`, { ...body, ...pickDevParams });
export const menuPosition = (id, position) => axiosInstance.post(`/appearance/menu/position/${id}`, { position, ...pickDevParams });
export const menuPages = (params) => axiosInstance.get('/appearance/menu/pages', { params: { ...params, ...pickDevParams } });
